import React from 'react';

import Modal from 'components/shared/Modal/Modal';
import Spinner from 'components/shared/spinner/spinner';

import LicenseForm from '../License/LicenseForm';

import EnrollmentModalFooter from './components/EnrollmentModalFooter';
import EnrollmentModalHeader from './components/EnrollmentModalHeader';
import LicenseSelectionTable from './components/LicenseSelectionTable';
import useEnrollmentModal from './lib/useEnrollmentModal';
import useLicenseColumns from './lib/useLicenseColumns';

const EnrollmentModal = ({
  isOpen,
  handleClose,
  provider,
  practiceId,
  onEnrollSuccess,
  isAdmin
}) => {
  const {
    selectedLicense,
    setSelectedLicense,
    showAddLicense,
    setShowAddLicense,
    showEditLicense,
    licenses,
    loadingLicenses,
    currentPage,
    setCurrentPage,
    totalItems,
    showPagination,
    paginatedLicenses,
    PAGE_SIZE,
    enrollMutation,
    upsertLicenseMutation,
    formik,
    handleEnroll,
    handleEditLicense
  } = useEnrollmentModal({ isOpen, provider, practiceId, onEnrollSuccess, handleClose });

  const { columnDefs, defaultColDef } = useLicenseColumns({
    selectedLicense,
    setSelectedLicense,
    onEditLicense: handleEditLicense,
    isAdmin
  });

  const renderContent = () => {
    if (loadingLicenses) {
      return (
        <div className="flex items-center justify-center py-8">
          <Spinner />
        </div>
      );
    }

    if (showAddLicense) {
      return (
        <div className="flex flex-col gap-4">
          <LicenseForm formik={formik} />
        </div>
      );
    }

    return (
      <LicenseSelectionTable
        paginatedLicenses={paginatedLicenses}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        showPagination={showPagination}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalItems={totalItems}
        pageSize={PAGE_SIZE}
      />
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      customHeader={
        <EnrollmentModalHeader
          showAddLicense={showAddLicense}
          setShowAddLicense={setShowAddLicense}
          licenses={licenses}
          showEditLicense={showEditLicense}
        />
      }
      slideFromRight
      className="!w-[800px]"
      footer={
        <EnrollmentModalFooter
          handleClose={handleClose}
          showAddLicense={showAddLicense}
          formik={formik}
          upsertLicenseMutation={upsertLicenseMutation}
          handleEnroll={handleEnroll}
          enrollMutation={enrollMutation}
          selectedLicense={selectedLicense}
        />
      }>
      {renderContent()}
    </Modal>
  );
};

export default EnrollmentModal;
